import React from 'react';
import { Globe, Target, MapPin } from 'lucide-react';
export function MarketOpportunity() {
  const markets = [{
    title: 'Total Addressable Market',
    acronym: 'TAM',
    value: '$800B',
    subtitle: 'Global Electricity Market',
    icon: Globe,
    color: 'from-blue-500/20 to-cyan-500/5',
    borderColor: 'border-blue-500/30'
  }, {
    title: 'Serviceable Addressable Market',
    acronym: 'SAM',
    value: '$200B',
    subtitle: 'North America',
    icon: Target,
    color: 'from-emerald-500/20 to-teal-500/5',
    borderColor: 'border-emerald-500/30'
  }, {
    title: 'Serviceable Obtainable Market',
    acronym: 'SOM',
    value: '$40B',
    subtitle: 'Canada',
    icon: MapPin,
    color: 'from-purple-500/20 to-fuchsia-500/5',
    borderColor: 'border-purple-500/30'
  }];
  return <section id="market" className="py-20 lg:py-32 bg-slate-900 relative" data-id="element-177">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <div className="text-center mb-16" data-id="element-179">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-180">
            Massive Market Potential
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-181">
            The transition to clean energy and circular waste management
            represents one of the largest economic opportunities of our
            generation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-182">
          {markets.map((market, index) => {
          const Icon = market.icon;
          return <div key={index} className={`relative overflow-hidden rounded-3xl bg-slate-950 border ${market.borderColor} p-8 hover:-translate-y-2 transition-transform duration-300 group`} data-id="element-183">
                <div className={`absolute inset-0 bg-gradient-to-b ${market.color} opacity-50 group-hover:opacity-100 transition-opacity duration-300`} data-id="element-184"></div>

                <div className="relative z-10 flex flex-col h-full" data-id="element-185">
                  <div className="flex justify-between items-start mb-8" data-id="element-186">
                    <div data-id="element-187">
                      <div className="text-sm font-bold text-slate-400 tracking-widest mb-1" data-id="element-188">
                        {market.acronym}
                      </div>
                      <h3 className="text-white font-medium" data-id="element-189">{market.title}</h3>
                    </div>
                    <div className="p-3 bg-slate-900 rounded-xl border border-slate-800" data-id="element-190">
                      <Icon className="w-6 h-6 text-slate-300" data-id="element-191" />
                    </div>
                  </div>

                  <div className="mt-auto pt-8 border-t border-slate-800/50" data-id="element-192">
                    <div className="text-5xl font-extrabold text-white tracking-tight mb-2" data-id="element-193">
                      {market.value}
                    </div>
                    <div className="text-slate-400 font-medium" data-id="element-194">
                      {market.subtitle}
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}